// Display formatting for the ISO dates stored on words. `revisedAt` is persisted
// as YYYY-MM-DD (the machine format used for filtering/sorting) but shown to
// users in long French form, e.g. "14 mars 2025".

const ISO_DATE_RE = /^(\d{4})-(\d{2})-(\d{2})/;

const frLongDate = new Intl.DateTimeFormat('fr-FR', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});

/**
 * Format an ISO date (YYYY-MM-DD, or a longer ISO datetime) as a long French
 * date. Falls back to returning the input unchanged when it isn't ISO — this
 * keeps legacy words persisted with a free-form `revisedAt` string rendering
 * sensibly instead of as "Invalid Date".
 */
export function formatRevisedDate(value: string): string {
  const match = ISO_DATE_RE.exec(value);
  if (!match) return value;
  const [, year, month, day] = match;
  // Construct from parts in local time so the displayed day never shifts across
  // time zones (unlike `new Date('2025-03-14')`, which parses as UTC midnight).
  const date = new Date(Number(year), Number(month) - 1, Number(day));
  return frLongDate.format(date);
}
